(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("fascino-http", [], factory);
	else if(typeof exports === 'object')
		exports["fascino-http"] = factory();
	else
		root["fascino-http"] = factory();
})(self, () => {
return 